import type { PasswordRule } from "./types";
import { TbCircleFilled, TbCheck } from "react-icons/tb";

interface RequirementsListProps {
    visibleRules: Array<PasswordRule & { passed: boolean }>;
}

const RequirementsList = ({ visibleRules }: RequirementsListProps) => (
    <div className='text-sm text-bash'>
        <ul className='space-y-1'>
            {visibleRules.map((rule) => (
                <li
                    key={rule.id}
                    className='flex gap-2 items-center font-medium'
                >
                    {rule.passed ? (
                        <TbCheck className='text-GREEN' size={16} />
                    ) : (
                        <TbCircleFilled className='text-ashShade-3' size={8} />
                    )}
                    {rule.label}
                </li>
            ))}
        </ul>
    </div>
);

export default RequirementsList;
